import { AlertTriangle, Loader2 } from "lucide-react";

export interface RendererProps {
  file: File;
  zoom: number;
}

export function LoadingViewer({ label }: { label: string }) {
  return (
    <div className="loading-viewer">
      <Loader2 size={22} className="spin" />
      <span>{label}</span>
    </div>
  );
}

export function ViewerError({ title, message }: { title: string; message: string }) {
  return (
    <div className="viewer-error">
      <AlertTriangle size={24} />
      <div>
        <strong>{title}</strong>
        <p>{message}</p>
      </div>
    </div>
  );
}
